<template>
  <div>
    <br />
    <div class v-if="data.data && data.data.length > 0">
      <a href data-toggle="modal" @click="download()">
        <button class="btn btn-outline-brand m-btn m-btn--outline">
          <i class="fas fa-download"></i> Baixar
        </button>
      </a>
    </div>
    <div>
      <div class="page-amounts">
        <nav aria-label="...">
          <ul class="pagination pagination-md">
            <li class="page-item" :class="{ selected: amount === 3 }">
              <a @click="amount = 3" class="page-link paginate">3</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 10 }">
              <a @click="amount = 10" class="page-link paginate">10</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 50 }">
              <a @click="amount = 50" class="page-link paginate">50</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 100 }">
              <a @click="amount = 100" class="page-link paginate">100</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 150 }">
              <a @click="amount = 150" class="page-link paginate">150</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="paginator-info-top m-2">
        <span class="m--font-gray" v-if="data.from"
          >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de {{ data.total }}.</span
        >
        <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
      </div>
    </div>

    <div class="table-responsive">
      <div class="container-table">
        <table class="table table-striped- table-bordered table-hover table-checkable">
          <thead>
            <tr>
              <td nowrap class="text-center" width="100">Mês</td>
              <td nowrap class="text-center" width="100">Clientes (IDs)</td>
              <td nowrap class="text-center" width="100">Usuário</td>
              <td nowrap class="text-center" width="60">Status</td>
              <td nowrap class="text-center" width="100">Data</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm m-input"
                  v-model="filters.customer_id"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm m-input"
                  v-model="filters.user_id"
                />
              </td>
              <td></td>
              <td></td>
            </tr>

            <tr v-for="(history, id) in data.data" :key="id">
              <td class="text-center">{{ history.billing_month | month }}</td>
              <td class="text-center">
                {{ history.customers_param ? history.customers_param : 'Todos' }}
              </td>
              <td class="text-center">{{ history.user_id ? history.user.name : 'Automático' }}</td>
              <td class="text-center font-weight-bold" :class="'status-' + history.status">
                {{ history.status | invoice_history_status }}
              </td>

              <td class="text-center">{{ history.created_at | date }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import { Money } from 'v-money';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportProcessingHistory',
  props: ['start', 'finish'],
  components: { Money },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      currentCompanyDiscountName: '',
      data: {},
      sortType: localStorage.customerDiscountSortType
        ? localStorage.customerDiscountSortType
        : 'id',
      sortReverse: localStorage.customerDiscountSortReverse
        ? localStorage.customerDiscountSortReverse
        : false,
      amount: localStorage.customerDiscountDataAmount
        ? localStorage.customerDiscountDataAmount
        : 100,
      page: localStorage.customerDiscountDataPage ? localStorage.customerDiscountDataPage : 1,
      filters: {
        id: localStorage.customerDiscountFilterId ? localStorage.customerDiscountFilterId : '',
        name: localStorage.customerDiscountFilterName
          ? localStorage.customerDiscountFilterName
          : '',
        user: localStorage.filterUser ? localStorage.filterUser : '',
        startDate: localStorage.startDate ? localStorage.startDate : '',
        finishDate: localStorage.finishDate ? localStorage.finishDate : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showCreateDiscount() {
      return this.$store.state.showCreateDiscount;
    },
    showCompanyDiscount() {
      return this.$store.state.showCompanyDiscount;
    },
  },
  methods: {
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    download() {
      const url = `${baseApiUrl}/v1/invoice/download-filtered-process-history${this.convertFilters()}`;

      axios
        .get(url)
        .then((res) => {
          const arrData = res.data.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
            ...arrData.map((item) => String(Object.values(item).join(';'))),
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', data);

          let fileName = `relatorio_historico_processamento`;

          if (this.start) {
            fileName += `_${this.start}-${this.finish}`;
          }

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);

          link.click();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando o relatório...',
        reason: '',
      };
      this.callData();
    },

    setStorageFilters() {
      localStorage.setItem('customerDiscountFilterId', this.filters.id);
      localStorage.setItem('customerDiscountFilterName', this.filters.name);
      localStorage.setItem('customerDiscountFilterAmount', this.filters.amount);
      localStorage.setItem('customerDiscountDataAmount', this.amount);
      localStorage.setItem('customerDiscountDataPage', this.page);
      localStorage.setItem('customerDiscountSortType', this.sortType);
      localStorage.setItem('customerDiscountSortReverse', this.sortReverse);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&amount=${this.amount}&sortType=${this.sortType}&sortOrder=${
        this.sortReverse ? 'DESC' : 'ASC'
      }&start=${this.start}&end=${this.finish}&username=${
        this.filters.user_id ? this.filters.user_id : ''
      }&month=${this.filters.month}&customer_id=${
        this.filters.customer_id ? this.filters.customer_id : ''
      }`;
      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType === sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getDatas() {
      this.getFilteredData();
    },
    getFilteredData() {
      const url = `${baseApiUrl}/v1/invoice/get-all-process-history${this.convertFilters()}`;

      axios
        .get(url)
        .then((res) => {
          this.data = res.data.data;
          this.clearAlert();
          this.$emit('updateLoading');
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>
<style scoped>
.status-queued {
  color: #ffc94f;
}
.status-finished {
  color: #00d86b;
}
.status-processing {
  color: #7592ff;
}
.status-error {
  color: #ff7575;
}
</style>
